(() => {
  'use strict';

  if (window.pfmHolidayMotion) {
    window.pfmHolidayMotion.init();
    return;
  }

  const key = 'pfm-holiday-reduced-motion';
  const controlSelector = '[data-pfm-holiday-motion-control]';
  const inputSelector = '[data-pfm-holiday-motion-input]';
  const boundInputs = new WeakSet();
  const previousCarouselPause = new WeakMap();
  const deviceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let userReduced = false;

  try { userReduced = localStorage.getItem(key) === 'reduce'; } catch (_) { /* Preference works for this page when storage is unavailable. */ }

  function updateCarousels(reduced) {
    document.querySelectorAll('pfm-fiber-carousel[data-initialized]').forEach(carousel => {
      if (!carousel.autoplayEnabled || typeof carousel.stopAutoplay !== 'function'
        || typeof carousel.scheduleAutoplay !== 'function' || typeof carousel.updateAutoplayControl !== 'function') return;
      if (reduced) {
        if (!previousCarouselPause.has(carousel)) previousCarouselPause.set(carousel, carousel.autoplayPausedByUser);
        carousel.autoplayPausedByUser = true;
        carousel.stopAutoplay();
        carousel.updateAutoplayControl();
      } else if (previousCarouselPause.has(carousel)) {
        carousel.autoplayPausedByUser = previousCarouselPause.get(carousel);
        previousCarouselPause.delete(carousel);
        carousel.scheduleAutoplay();
      }
    });
  }

  function apply() {
    const controls = document.querySelectorAll(controlSelector);
    if (!controls.length) {
      document.documentElement.removeAttribute('data-pfm-holiday-motion');
      updateCarousels(false);
      return;
    }
    const reduced = deviceMotion.matches || userReduced;
    document.documentElement.setAttribute('data-pfm-holiday-motion', reduced ? 'reduced' : 'running');
    updateCarousels(reduced);
    controls.forEach(control => {
      const input = control.querySelector(inputSelector);
      if (!input) return;
      input.checked = reduced;
      input.disabled = deviceMotion.matches;
      control.title = deviceMotion.matches ? 'Reduced motion is enabled on your device.' : '';
      control.hidden = false;
    });
  }

  function init() {
    document.querySelectorAll(inputSelector).forEach(input => {
      if (boundInputs.has(input)) return;
      boundInputs.add(input);
      input.addEventListener('change', () => {
        userReduced = input.checked;
        try {
          if (userReduced) localStorage.setItem(key, 'reduce');
          else localStorage.removeItem(key);
        } catch (_) { /* Keep the current choice without persistent storage. */ }
        apply();
      });
    });
    apply();
  }

  if (deviceMotion.addEventListener) deviceMotion.addEventListener('change', apply);
  else deviceMotion.addListener(apply);
  window.addEventListener('storage', event => {
    if (event.key !== key) return;
    userReduced = event.newValue === 'reduce';
    apply();
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(init));
  customElements.whenDefined('pfm-fiber-carousel').then(() => requestAnimationFrame(apply));
  window.pfmHolidayMotion = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
